import { getConfig } from "./config";

export const msalConfig = {
  auth: {
    clientId: getConfig(
      "REACT_APP_CLIENT_ID",
      "36df0d64-b5a0-4970-975f-69bbfa7e34b7",
    ),
    authority: "https://login.microsoftonline.com/common", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    // Keep local development and tunneled access on the same browser origin.
    redirectUri: getConfig("REACT_APP_MSAL_REDIRECT_URI", "/auth"),
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set to true to avoid cross-protocol iframe issues in development
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
